const buttonClasses = 'bg-primary-600 text-white';

const buttonHoverClasses = 'hover:bg-primary-900';

const buttonIconClasses = 'fill-white';

const buttonPrimaryClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonPrimaryClasses;
